import React from 'react';
import './TeamCare.css';

function TeamCare({ onConsultationClick, onLearnMoreClick }) {
  return (
    <section className="ttc-team-care-wrapper py-5">
      <div className="container py-lg-4">
        <div className="row align-items-center justify-content-between mb-4 mb-lg-5 gy-3">
          <div className="col-12 col-md-6">
            <h2 className="ttc-team-heading mb-0">
              Team-Led <span className="ttc-team-heading-serif">Care</span>
            </h2>
          </div>
          <div className="col-12 col-md-6 col-lg-5">
            <p className="ttc-team-subtext mb-3">
              For Over 15 Years, The Toronto Clinic Has Led The Way In Preventative, Collaborative Healthcare. Bringing The Best Minds Together, Serving Those Who Expect More From Medicine.
            </p>
            <button 
              type="button" 
              onClick={onConsultationClick} 
              className="btn ttc-team-btn-primary d-inline-flex align-items-center gap-2"
            >
              <span>Book A Consultation</span>
              <span className="ttc-team-btn-icon">↗</span>
            </button>
          </div>
        </div>

        <div className="row g-4 align-items-stretch">
          <div className="col-12 col-lg-6 d-flex">
            <div className="ttc-team-bio-card w-100 p-4 p-md-5 d-flex flex-column justify-content-between">
              <div>
                <h3 className="ttc-team-doctor-name mb-3">DR. FABIO VARLESE</h3>
                <h4 className="ttc-team-doctor-role mb-4">Founder of The Toronto Clinic</h4>
                <p className="ttc-team-doctor-desc mb-4">
                  Dr. Varlese's work is dedicated to enhancing the quality of life and developing innovation to reduce unnecessary...
                </p>
              </div>
              <div>
                {/* <button 
                  type="button" 
                  onClick={onLearnMoreClick} 
                  className="btn ttc-team-btn-white d-inline-flex align-items-center justify-content-between gap-3"
                >
                  <span>Learn More</span>
                  <span className="ttc-team-btn-blue-icon">→</span>
                </button> */}
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="ttc-team-image-box position-relative h-100">
              <img 
                src="/images/creatives/team-1.png" 
                alt="Dr. Fabio Varlese" 
                className="img-fluid w-100 h-100 ttc-team-img"
              />
              <div className="ttc-team-credentials-badge">
                MD, MSc, FRCPC
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeamCare;